<section id="user-calendar-stats-view">
    <div *ngIf="stats" class="user-calendar-stats mb-4">
        <!-- <div class="row">
            <div class="col-12">
                <div class="content-header">Estadísticas del calendario</div>
                <p class="content-sub-header mb-1">Estadísticas de los eventos.</p>
            </div>
        </div> -->
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-12">
                        <div class="content-header">Vacaciones</div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body text-left">
                                            <h3 class="mb-1 success" [countUp]="stats.total_accepted_holidays"></h3>
                                            <span>Aceptadas</span>
                                        </div>
                                        <div class="media-right align-self-center">
                                            <i class="ft-image success font-large-2 float-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body text-left">
                                            <h3 class="mb-1 info" [countUp]="stats.total_pending_holidays"></h3>
                                            <span>Pendientes</span>
                                        </div>
                                        <div class="media-right align-self-center">
                                            <i class="ft-image info font-large-2 float-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body text-left">
                                            <h3 class="mb-1 warning" [countUp]="stats.total_prev_year_holidays"></h3>
                                            <span>Año Anterior</span>
                                        </div>
                                        <div class="media-right align-self-center">
                                            <i class="ft-image warning font-large-2 float-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-12">
                        <div class="content-header">Asuntos Propios</div>
                    </div>
                </div>
                <div class="row">

                    <div class="col-lg-6 col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body text-left">
                                            <h3 class="mb-1 success" [countUp]="stats.total_accepted_personal_matters">
                                            </h3>
                                            <span>Aceptados</span>
                                        </div>
                                        <div class="media-right align-self-center">
                                            <i class="icon-notebook success font-large-2 float-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body text-left">
                                            <h3 class="mb-1 info" [countUp]="stats.total_pending_personal_matters"></h3>
                                            <span>Pendientes</span>
                                        </div>
                                        <div class="media-right align-self-center">
                                            <i class="icon-notebook info font-large-2 float-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-12">
                        <div class="content-header">Bajas</div>
                    </div>
                </div>
                <div class="row">

                    <div class="col-lg-6 col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body text-left">
                                            <h3 class="mb-1 success" [countUp]="stats.total_accepted_sick_leave"></h3>
                                            <span>Aceptadas</span>
                                        </div>
                                        <div class="media-right align-self-center">
                                            <i class="ft-home success font-large-2 float-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body text-left">
                                            <h3 class="mb-1 info" [countUp]="stats.total_pending_sick_leave"></h3>
                                            <span>Pendientes</span>
                                        </div>
                                        <div class="media-right align-self-center">
                                            <i class="ft-home info font-large-2 float-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-12">
                        <div class="content-header">Teletrabajo</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body text-left">
                                            <h3 class="mb-1 success" [countUp]="stats.total_accepted_remote_work"></h3>
                                            <span>Aceptados</span>
                                        </div>
                                        <div class="media-right align-self-center">
                                            <i class="ft-monitor success font-large-2 float-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body text-left">
                                            <h3 class="mb-1 info" [countUp]="stats.total_pending_remote_work"></h3>
                                            <span>Pendientes</span>
                                        </div>
                                        <div class="media-right align-self-center">
                                            <i class="ft-monitor info font-large-2 float-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-12">
                        <div class="content-header">Permisos Retribuidos</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body text-left">
                                            <h3 class="mb-1 success" [countUp]="stats.total_accepted_paid_leave"></h3>
                                            <span>Aceptados</span>
                                        </div>
                                        <div class="media-right align-self-center">
                                            <i class="ft-dollar-sign success font-large-2 float-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body text-left">
                                            <h3 class="mb-1 info" [countUp]="stats.total_pending_paid_leave"></h3>
                                            <span>Pendientes</span>
                                        </div>
                                        <div class="media-right align-self-center">
                                            <i class="ft-dollar-sign info font-large-2 float-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="calendars" class="calendar mb-4">
        <full-calendar [options]="calendarOptions"></full-calendar>
    </div>
</section>

<ngx-spinner></ngx-spinner>